import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_CEMENT_BRANDS);

const BCMBrandCement = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_CEMENT_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['UltraTech Cement', 'ACC Cement', 'Ambuja Cement', 'Dalmia Cement', 'Shree Cement']}
      icon={PROFILER_IMAGES.cement}
      {...props}
    />
  )
}

export default BCMBrandCement
